import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Archive from "@/pages/Archive";
import LessonDetail from "@/pages/LessonDetail";
import Community from "@/pages/Community";
import About from "@/pages/About";
import StatementOfFaith from "@/pages/StatementOfFaith";
import FamilyPack from "@/pages/FamilyPack";
import Admin from "@/pages/Admin";
import Rewards from "@/pages/Rewards";
import BibleNavigator from "@/pages/BibleNavigator";
import Unsubscribe from "@/pages/Unsubscribe";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route element={<Layout />}>
                        <Route path="/" element={<Home />} />
                        <Route path="/lessons" element={<Archive />} />
                        <Route path="/lessons/:id" element={<LessonDetail />} />
                        <Route path="/bible" element={<BibleNavigator />} />
                        <Route path="/rewards" element={<Rewards />} />
                        <Route path="/community" element={<Community />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/faith" element={<StatementOfFaith />} />
                        <Route path="/family-pack" element={<FamilyPack />} />
                        <Route path="/admin" element={<Admin />} />
                        <Route path="/unsubscribe" element={<Unsubscribe />} />
                    </Route>
                </Routes>
            </BrowserRouter>
            <Toaster richColors position="top-center" />
        </div>
    );
}

export default App;
